import { lightenColor } from "./lightenColor"

export const calcPercentAndColor = (current, preview, showPreview, color) => {
  let firstColor = lightenColor(color, 80)
  let secondColor = "lightgrey"

  let firstNumber = showPreview ? preview : current
  let secondNumber = showPreview ? current - preview : 0

  if (preview > current) {
    firstNumber = current
    secondNumber = preview - current
    // firstColor = lightenColor(color, 80)
    // secondColor = "lightgreen"
    firstColor = lightenColor(color, 50)
    secondColor = lightenColor(color, 95)
  }

  let percent = [firstNumber, secondNumber]
  let strokeColor = [firstColor, secondColor]

  return { percent, strokeColor }
}
